import { SignDTO, SignDTOListBaseResponse } from "@api/client";
import { createReducer } from "@reduxjs/toolkit";
import { AppSearchboxActiveFilter } from "shared/design-system/components/app-searchbox/types.models";
import { BaseSortDir } from "shared/design-system/models/base.model";
import {
	signAddFilter,
	signDeleteFilter,
	signGetList,
	signSetTablePage,
	signSetTablePageSize,
	signSetTableSort,
} from "./actions";

interface InitialValues {
	page: number;
	pageSize: number;
	orderBy: keyof SignDTO | undefined;
	orderByDir: BaseSortDir | undefined;
	filters: AppSearchboxActiveFilter[];
	listResponse: SignDTOListBaseResponse | undefined;
}

const initialState: InitialValues = {
	page: 1,
	pageSize: 10,
	orderBy: "title",
	orderByDir: "asc",
	filters: [],
	listResponse: undefined,
};

export const signReducer = createReducer(initialState, (builder) => {
	builder
		.addCase(signSetTablePage, (state, action) => {
			state.page = action.payload;
		})
		.addCase(signSetTablePageSize, (state, action) => {
			state.page = 1;
			state.pageSize = action.payload;
		})
		.addCase(signAddFilter, (state, action) => {
			state.filters.push(action.payload);
		})
		.addCase(signDeleteFilter, (state, action) => {
			state.filters = state.filters.filter((f) => f.key != action.payload);
		})
		.addCase(signSetTableSort, (state, action) => {
			state.orderByDir =
				state.orderBy == action?.payload
					? state.orderByDir == "asc"
						? "desc"
						: "asc"
					: state.orderByDir;
			state.orderBy = action?.payload;
		})
		.addCase(signGetList.pending, (state, action) => {
			state.listResponse = undefined;
		})
		.addCase(signGetList.fulfilled, (state, action) => {
			state.listResponse = action.payload;
		});
});
